import React, { useState } from 'react';
import { 
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Alert,
  LinearProgress,
  Collapse
} from '@mui/material';
import { 
  Visibility, 
  VisibilityOff,
  Lock,
  VpnKey,
  CheckCircle
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const form_API = (props) => {
  const theme = useTheme();
  const [showSecret, setShowSecret] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [touched, setTouched] = useState({
    API: false,
    Secret: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await props.submit();
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBlur = (field) => () => {
    setTouched(prev => ({ ...prev, [field]: true }));
  };

  const isApiValid = props.API.length >= 20;
  const isSecretValid = props.Secret.length >= 20;

  return (
    <Card elevation={3} sx={{ maxWidth: 500, mx: 'auto' }}>
      <CardContent>
        <Typography 
          variant="h6" 
          gutterBottom
          sx={{ 
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: theme.palette.text.primary
          }}
        >
          <Lock fontSize="small" /> {props.title}
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="API Key"
            variant="outlined"
            value={props.API}
            onChange={props.changeAPI}
            onBlur={handleBlur('API')}
            error={touched.API && !isApiValid}
            helperText={touched.API && !isApiValid ? 'API Key must be at least 20 characters' : ''}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKey color="action" />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 3 }}
          />

          <TextField
            fullWidth
            label="Secret Key"
            type={showSecret ? 'text' : 'password'}
            value={props.Secret}
            onChange={props.changeSecret}
            onBlur={handleBlur('Secret')}
            error={touched.Secret && !isSecretValid}
            helperText={touched.Secret && !isSecretValid ? 'Secret Key must be at least 20 characters' : ''}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock color="action" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowSecret(!showSecret)}
                    edge="end"
                  >
                    {showSecret ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ mb: 3 }}
          />

          <Collapse in={isSubmitting}>
            <LinearProgress sx={{ mb: 2 }} />
          </Collapse>

          <Collapse in={showSuccess}>
            <Alert 
              icon={<CheckCircle fontSize="inherit" />} 
              severity="success"
              sx={{ mb: 2 }}
            >
              Credentials validated successfully!
            </Alert>
          </Collapse>

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting || !isApiValid || !isSecretValid}
            size="large"
            startIcon={<Lock />}
          >
            {isSubmitting ? 'Verifying...' : 'Connect API'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default form_API;